import { configurationBase, sourceFileTypes, apiAuthenticationTypes, iMappingField } from "@/models/importModels";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import baseContextComponent from "../baseContextComponent";
import datePicker from "vue-bootstrap-datetimepicker";

@Component({ components: { datePicker } })
export default class columnsMappingBase extends baseContextComponent {
	@Prop({ default: () => [] })
	value: iMappingField[];
	optionsDateTimePicker: any = {
		//format: 'DD/MM/YYYY HH:mm:ss',
		extraFormats: ["YYYY-MM-DDThh:mm:ssZ"],
		useCurrent: false,
		showClear: true,
		showClose: true,
		locale: 'it',
		icons: {
			time: "fa fa-clock",
			date: "fa fa-calendar",
			up: "fa fa-arrow-up",
			down: "fa fa-arrow-down",
			previous: "fa fa-chevron-left",
			next: "fa fa-chevron-right",
			today: "fa fa-clock",
			clear: "fa fa-trash"
		},
		tooltips: {
			today: 'Oggi',
			clear: 'Cancella selezione',
			close: 'Chiudi',
			selectMonth: 'Seleziona mese',
			prevMonth: 'Mese precedente',
			nextMonth: 'Mese successivo',
			selectYear: 'Seleziona anno',
			prevYear: 'Anno precendente',
			nextYear: 'Anno successivo',
			selectDecade: 'Seleziona decade',
			prevDecade: 'Decade precedente',
			nextDecade: 'Decade successiva'
		}
	};

	get list(): iMappingField[] {
		return this.value;
	}
	set list(value: iMappingField[]) {
		this.$emit("input", value);
	}
	getComponentName(m: iMappingField): string {
		return `input-type-${m.columnDataType}`;
	}
	isComponentDefined(nameOfComponent: string): boolean {
		var self = this;
		var b = self.$options.components[nameOfComponent];
		return b != null;
	}
	onConfigClick(m: iMappingField) {
		this.$emit("configField", m);
	}
	openCalendar(columnName) {
		var self = this;
		(self.$refs[columnName] as any)[0].dp.toggle();
	}
}
